import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-force',
  templateUrl: './mobile-force.component.html',
  styleUrls: ['./mobile-force.component.scss']
})
export class MobileForceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/mobile-force/mobile-force.component.ts